export const isCodexUi = process.env.REACT_APP_CODEX_UI === 'true';
export const codexAuthState = process.env.REACT_APP_CODEX_AUTH_STATE || 'authenticated';
export const isCodexUnauthenticated = codexAuthState === 'unauthenticated';
export const isCodexApiMockEnabled =
  process.env.REACT_APP_API_MOCK === 'true' || isCodexUi;
// Hybrid mode: mock only auth, let API calls go to real backend
export const isHybridMockEnabled =
  process.env.REACT_APP_HYBRID_MOCK === 'true';
